export interface ITipoMaterial {
  ocorrenciaNo: number;
  codigo: number;
  materialId: number;
  titulo: string;
  habilitado: boolean;
}
